import { useCallback } from "react";
import ReduxFetchState from "redux-fetch-state";
import { put, takeEvery } from "redux-saga/effects";
import axios from "../../../../Utils/axiosConfig";
import { getCurrentLanguage } from "../../../../Utils/sagaHelpers";
import { useAppDispatch, useAppSelector } from "../../../../Hooks/useStore";
import { GetUserHistoryDataTypes } from "../../../../Schema/getUserHistory.types";
import { call } from "@redux-saga/core/effects";
import { queryClient } from "../../../store";

export type GetUserHistoryLoadAction = {
  type: string;
  payload: { page: number; types?: string | null };
};

export type GetUserHistoryData = {
  data: {
    categories: { message: string; id: number }[];
    user_services: GetUserHistoryDataTypes;
  };
};

export const GetUserHistory = new ReduxFetchState<
  GetUserHistoryData | null,
  { page: number; types?: string | null },
  any
>("getUserHistory");

export function* watchGetUserHistory(action: GetUserHistoryLoadAction) {
  try {
    const lang: "fa" | "en" = yield getCurrentLanguage();

    const data: GetUserHistoryData = yield call([queryClient, queryClient.fetchQuery], {
      queryKey: ["getUserHistory", lang],
      queryFn: async () => {
        const res = await axios({
          url: `/api/v1/ai/user-service/history?page=${action.payload.page}${action.payload.types ? `&filter_category=${action.payload.types}` : ""}`,
          method: "GET",
          headers: { lang },
        });
        return { data: res.data };
      },
      staleTime: 1440 * 60 * 1000,
    });

    yield put(GetUserHistory.actions.loadSuccess({ data: data.data }));
  } catch (e: any) {
    yield put(GetUserHistory.actions.loadFailure(e?.response?.data));
  }
}

export function* getUserHistorySagas() {
  yield takeEvery(GetUserHistory.actionTypes.load, watchGetUserHistory);
}

export function useGetUserHistory() {
  const { loading, data, ...getUserHistoryState } = useAppSelector((state) => state.getUserHistory);
  const dispatch = useAppDispatch();

  const dispatchGetUserHistory = useCallback(
    (data: { page: number; types?: string | null }) => {
      dispatch(GetUserHistory.actions.load(data));
    },
    [dispatch],
  );

  return {
    ...getUserHistoryState,
    dispatchGetUserHistory,
    getUserHistoryLoading: loading,
    getUserHistoryData: data,
  };
}

export const {
  actionTypes: getUserHistoryActionsTypes,
  actions: getUserHistoryActions,
  reducer: getUserHistoryReducer,
} = GetUserHistory;
